"use client";

import { MapPin, CheckCircle2 } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurLocations() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll();
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll();

  // Lista completa de áreas de servicio
  const areas = ["Miami Beach", "South Miami", "Kendall", "Opa-Locka", "Broward", "Fort Lauderdale"];
  return <section id="ourlocations" className="relative bg-dark-background py-20 md:py-28 lg:py-32 overflow-hidden border-t border-border/10">
      {/* TEXTURA DE FONDO */}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/aerial_city_texture.png)] bg-cover bg-center opacity-10 pointer-events-none" aria-hidden="true" />

      {/* GRADIENTE SUTIL */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-secondary/5 pointer-events-none" />

      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {/* COLUMNA IZQUIERDA: Textos y Lista de Áreas */}
          <div ref={leftRef} className={`order-2 lg:order-1 flex flex-col justify-center transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <p className="text-sm font-semibold tracking-widest uppercase text-secondary mb-4 drop-shadow-sm">
              Local Service
            </p>
            
            {/* TÍTULO CON EL ICONO AL LADO */}
            <div className="flex items-center gap-4 mb-6">
              <MapPin className="w-10 h-10 md:w-12 md:h-12 text-secondary drop-shadow-[0_0_12px_rgba(var(--secondary),0.5)] flex-shrink-0" strokeWidth={2.5} />
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold tracking-tight text-white drop-shadow-sm">
                Our Service Area
              </h2>
            </div>

            <p className="text-white/80 text-lg md:text-xl mb-10 leading-relaxed drop-shadow-sm max-w-xl">
              We bring our expertise directly to you. Based in Miami, Florida, we provide fast and reliable mobile plumbing services throughout South Florida and surrounding regions.
            </p>

            {/* Lista de ubicaciones */}
            <div className="pt-8 border-t border-white/10">
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                {areas.map((area, i) => <li key={i} className="flex items-center gap-3 text-lg text-white font-medium drop-shadow-sm hover:text-secondary transition-colors duration-300">
                    {/* ICONO CORREGIDO: Usando text-secondary y un ligero drop-shadow */}
                    <CheckCircle2 className="w-6 h-6 text-secondary drop-shadow-[0_0_8px_rgba(var(--secondary),0.4)] flex-shrink-0" strokeWidth={2.5} />
                    {area}
                  </li>)}
              </ul>
            </div>
          </div>

          {/* COLUMNA DERECHA: Mapa interactivo */}
          <div ref={rightRef} className={`order-1 lg:order-2 transition-all duration-700 ease-out delay-150 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div className="relative h-[400px] md:h-[450px] lg:h-[550px] rounded-2xl overflow-hidden shadow-strong border border-white/10 bg-background/5 backdrop-blur-sm p-2">
              {/* Mapa centrado en el área de Miami/Broward */}
              <iframe title="Service Area Map" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Miami,FL+(AA%20Eagle%20Plumbing)&amp;t=&amp;z=10&amp;ie=UTF8&amp;iwloc=B&amp;output=embed" className="absolute inset-2 w-[calc(100%-16px)] h-[calc(100%-16px)] rounded-xl" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen />
            </div>
          </div>

        </div>
      </div>
    </section>;
}